export const PAGE_SIZE = 10;
const SPEND_COL_MIN_WIDTH = 111;

export const getColumnDefsByType = (
	dimension,
	companies,
	spendFormatter,
	showState,
	sortModel,
	showTotalSpend
) => {
	return [
		{
			headerName: dimension === 'vendor' ? 'Vendors' : 'Category',
			field: 'name',
			colId: 'name',
			minWidth: 190,
			sortable: true,
			...(sortModel && sortModel.colId === 'name'
				? { sort: sortModel.sort }
				: {}),
		},
		{
			headerName: showState ? 'State' : 'Country',
			field: 'location',
			colId: 'location',
			minWidth: 112,
			maxWidth: 150,
			sortable: true,
			...(sortModel && sortModel.colId === 'location'
				? { sort: sortModel.sort }
				: {}),
		},
		...(showTotalSpend
			? [
					{
						headerName: 'Total spend',
						field: 'totalSpend',
						colId: 'totalSpend',
						type: 'numericColumn',
						headerClass: 'ag-numeric-header',
						cellStyle: { direction: 'rtl' },
						minWidth: SPEND_COL_MIN_WIDTH,
						sortable: true,
						...(sortModel && sortModel.colId === 'totalSpend'
							? { sort: sortModel.sort }
							: {}),
						valueFormatter: params => spendFormatter(params.value),
					},
			  ]
			: [
					{
						headerName: 'Direct spend',
						field: 'directSpend',
						colId: 'directSpend',
						type: 'numericColumn',
						headerClass: 'ag-numeric-header',
						cellStyle: { direction: 'rtl' },
						minWidth: SPEND_COL_MIN_WIDTH,
						maxWidth: 122,
						sortable: true,
						...(sortModel && sortModel.colId === 'directSpend'
							? { sort: sortModel.sort }
							: {}),
						valueFormatter: params => spendFormatter(params.value),
					},
					{
						headerName: 'Indirect spend',
						field: 'indirectSpend',
						colId: 'indirectSpend',
						type: 'numericColumn',
						headerClass: 'ag-numeric-header',
						cellStyle: { direction: 'rtl' },
						minWidth: SPEND_COL_MIN_WIDTH,
						maxWidth: 122,
						sortable: true,
						...(sortModel && sortModel.colId === 'indirectSpend'
							? { sort: sortModel.sort }
							: {}),
						valueFormatter: params => spendFormatter(params.value),
					},
			  ]),

		...companies.map((companyName, index) => ({
			headerName: companyName,
			headerClass: `ag-numeric-header company-header color-${index + 1}`,
			colId: companyName,
			type: 'numericColumn',
			cellStyle: { direction: 'rtl' },
			minWidth: SPEND_COL_MIN_WIDTH,
			sortable: true,
			...(sortModel && sortModel.colId === companyName
				? { sort: sortModel.sort }
				: {}),
			valueGetter: params => {
				return (
					params &&
					params.data &&
					params.data.companies &&
					params.data.companies[index]
				);
			},
			valueFormatter: params => spendFormatter(params.value),
		})),
	];
};
